export enum GridConfigName {
  TenantGridConfig = 'TenantGridConfig',
  MachineGridConfig = 'MachineGridConfig',
  UserGridConfig = 'UserGridConfig',
}
